// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.up-profile-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /*gap: 10px; */ 
  padding: 10px;
  margin-left: 30px;
}
.up-text-label {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: "normal";
  margin-left: 10px;
  margin-top: 10px;

}

.up-text-input {
  margin-top: 10px;
  margin-left: 20px;
  border-radius: 10px;
  width: 500px;
  height: 40px;
  background: gray;
}

.up-text-subheader {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 30px;
  font-weight: "bold";
  margin-top: 30px;
}

.up-text-header {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 35px;
  font-weight: "bold";
}

.overlay-grid-layout {
    width: "100%";
    display: flex;
    flex-direction: row;
    height: "1000px";
}

.up-blog-grid-upper {
    display: flex;
    flex-direction: row;
    overflow: "hidden";
    margin-left: 10px;
}

.up-blog-grid-lower {
    overflow: "hidden";
    display: flex;
    flex-direction: row;
    gap: 20px;
}

.up-profile-card {
    margin-top: 10px;
    width: 200px;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    text-align: center;
    transition: transform 0.3s ease-in-out;
    background: rgb(34, 31, 31);
    margin-left: 10px;
  }
  
  .up-profile-card:hover {
    transform: scale(1.05); /* Subtle hover effect */
  }
  
  .up-profile {
    width: 90%;
    height: 50%;
    background: none;
    padding: 10px;
  }

  .up-image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .up-details {
    width: 100%;
    height: 40%;
    background: none;
    padding: 10px;
  }
  
  .up-details h4 {
    margin: 5px 0;
    font-size: 16px;
    font-weight: bold;
  }

  /* .up-text-label {
    
  } */

  .common-btn-format {
    width: 70px;
    height: 40px;
    background: gray;
    border-radius: 10px;
    margin-left: 10px;
    font-family: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif";
    font-size: 20px;
    font-weight: "bold";
    justify-items: center;
  }

  .common-btn-format:hover {
    background: darkgray;
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/common-styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,sBAAsB,EAAE,wBAAwB;EAClD;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;;EAEA;;KAEG;;EAEH;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,uGAAuG;IACvG,eAAe;IACf,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB","sourcesContent":[".up-profile-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  /*gap: 10px; */ \n  padding: 10px;\n  margin-left: 30px;\n}\n.up-text-label {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 20px;\n  font-weight: \"normal\";\n  margin-left: 10px;\n  margin-top: 10px;\n\n}\n\n.up-text-input {\n  margin-top: 10px;\n  margin-left: 20px;\n  border-radius: 10px;\n  width: 500px;\n  height: 40px;\n  background: gray;\n}\n\n.up-text-subheader {\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n  font-size: 30px;\n  font-weight: \"bold\";\n  margin-top: 30px;\n}\n\n.up-text-header {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 35px;\n  font-weight: \"bold\";\n}\n\n.overlay-grid-layout {\n    width: \"100%\";\n    display: flex;\n    flex-direction: row;\n    height: \"1000px\";\n}\n\n.up-blog-grid-upper {\n    display: flex;\n    flex-direction: row;\n    overflow: \"hidden\";\n    margin-left: 10px;\n}\n\n.up-blog-grid-lower {\n    overflow: \"hidden\";\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n}\n\n.up-profile-card {\n    margin-top: 10px;\n    width: 200px;\n    height: 200px;\n    border-radius: 12px;\n    overflow: hidden;\n    text-align: center;\n    transition: transform 0.3s ease-in-out;\n    background: rgb(34, 31, 31);\n    margin-left: 10px;\n  }\n  \n  .up-profile-card:hover {\n    transform: scale(1.05); /* Subtle hover effect */\n  }\n  \n  .up-profile {\n    width: 90%;\n    height: 50%;\n    background: none;\n    padding: 10px;\n  }\n\n  .up-image {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  \n  .up-details {\n    width: 100%;\n    height: 40%;\n    background: none;\n    padding: 10px;\n  }\n  \n  .up-details h4 {\n    margin: 5px 0;\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  /* .up-text-label {\n    \n  } */\n\n  .common-btn-format {\n    width: 70px;\n    height: 40px;\n    background: gray;\n    border-radius: 10px;\n    margin-left: 10px;\n    font-family: \"'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif\";\n    font-size: 20px;\n    font-weight: \"bold\";\n    justify-items: center;\n  }\n\n  .common-btn-format:hover {\n    background: darkgray;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
